import { render, staticRenderFns } from "./EditDigistaffDialog.vue?vue&type=template&id=31479368"
import script from "./EditDigistaffDialog.vue?vue&type=script&lang=js"
export * from "./EditDigistaffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports